import { Component, OnInit } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';

@Component({
  selector: 'app-authenticated-no-group-membership',
  templateUrl: './authenticated-no-group-membership.component.html',
  styleUrls: ['./authenticated-no-group-membership.component.scss'],
})
export class AuthenticatedNoGroupMembershipComponent implements OnInit {
  myGroups: IdentityEntityGroup[];

  constructor(private identityService: IdentityService) {}

  ngOnInit(): void {
    this.myGroups = this.identityService.identity.entityGroups;
  }
}
